module.exports = __webpack_public_path__ + "9f444a59f675fb7804e488bf587a0cee.svg";